// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PostMenu__item--admin":"qq_a","PostMenu__item--moderator":"qq_b","PostMenu__item--author":"qq_c"};